import React, { lazy, Suspense } from "react";
import { useParams } from "react-router";
import { ErrorBoundary } from "react-error-boundary";
import Loader from "./components/molecules/Loading";
const Geolocation = lazy(
  () => import("./components/pages/Geolocation/Geolocation")
);

export interface ErrorHandlerProps {
  error: Error;
  readonly resetErrorBoundary: () => void;
}

export function ErrorHandler({
  error,
  resetErrorBoundary,
}: Readonly<ErrorHandlerProps>) {
  return (
    <div role="alert">
      <p>An error occurred:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

const App = () => {
  const { correlationId = "1a" } = useParams<{
    correlationId: string;
  }>();
  return (
    <ErrorBoundary FallbackComponent={ErrorHandler}>
      <Suspense fallback={<Loader />}>
        <Geolocation correlationId={correlationId} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
